import { resolve, reject } from 'redux-optimist-promise';
import { get } from 'lodash';
import createReducer from 'Store/utils/createReducer';
import { PRICE_TICKET_REQUEST } from './constants';
const initialState = {
  isLoading: true,
  productArgs: '',
  price: {},
};
export default createReducer(initialState, {
  [PRICE_TICKET_REQUEST](state: ReduxState, action: PriceTicketRequestResolvedAction) {
    return { ...state, isLoading: true, productArgs: action.payload?.productArgs };
  },

  [resolve(PRICE_TICKET_REQUEST)](
    state: ReduxState,
    action: PriceTicketRequestResolvedAction,
  ): ReduxState {
    const price = get(action, 'payload.price') || {};
    return { ...state, isLoading: false, price };
  },

  [reject(PRICE_TICKET_REQUEST)](state: ReduxState): ReduxState {
    return { ...state, isLoading: false };
  },
});
